import { Component, Input, OnInit } from '@angular/core';
import { UserProfile } from 'src/app/model/userProfile.model';

let audioContext;
let currentCell = null;
let statusElement;
let tableElement;
let websocket: WebSocket;
let finalsReceived;
let youtube_link;
let seq = 1;

@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.css',
    '../../../../node_modules/primeflex/primeflex.css']
})
export class StreamingComponent implements OnInit {
  @Input() user: UserProfile;

  speachToTextDesc = 'Click on the microphone and begin speaking.';
  isStreaming = false;
  streamTo = null;
  destinations: any[];

  constructor() {
    this.destinations = [
      { label: 'Youtube', value: 'youtube' },
      { label: 'Twitch', value: 'twitch' }
    ]
  }

  ngOnInit(): void {
  }


  doStream() {

    if (this.user && this.user.revai_access_token && this.user.standard_subscribe_id && (this.user.youtube_link && this.streamTo === 'youtube')) {
      youtube_link = this.user.youtube_link;
      seq = 1;
      audioContext = new (window.AudioContext)();
      statusElement = document.getElementById('status');
      tableElement = document.getElementById('messages');

      const content_type = `audio/x-raw;layout=interleaved;rate=${audioContext.sampleRate};format=S16LE;channels=1`;
      const baseUrl = 'wss://api.rev.ai/speechtotext/v1alpha/stream';
      const query = `access_token=${this.user.revai_access_token}&content_type=${content_type}`;
      websocket = new WebSocket(`${baseUrl}?${query}`);

      websocket.onopen = onOpen;
      websocket.onclose = onClose;
      websocket.onmessage = onMessage;
      websocket.onerror = console.error;
      this.isStreaming = true;
      this.speachToTextDesc = 'Speak Now - ';
    }
  }

  stopStream() {
    if (websocket) {
      websocket.send("EOS");
      websocket.close();
    }
    if (audioContext) {
      audioContext.close();
    }
    this.isStreaming = false;
    this.speachToTextDesc = 'Click on the microphone and begin speaking.';
  }

}


/**
 * Updates the display and creates the link from the AudioContext and the websocket connection to rev.ai
 * @param {Event} event 
 */
function onOpen(event) {
  resetDisplay();
  statusElement.innerHTML = "Opened";
  navigator.mediaDevices.getUserMedia({ audio: true }).then((micStream) => {
    audioContext.suspend();
    const scriptNode = audioContext.createScriptProcessor(4096, 1, 1);
    var input = input = audioContext.createMediaStreamSource(micStream);
    scriptNode.addEventListener('audioprocess', (event) => processAudioEvent(event));
    input.connect(scriptNode);
    scriptNode.connect(audioContext.destination);
    audioContext.resume();
  });
}



/**
* Displays the close reason and code on the webpage
* @param {CloseEvent} event
*/
function onClose(event) {
  statusElement.innerHTML = `Closed`;
}

/**
* Handles messages received from the API according to our protocol
* https://www.rev.ai/docs/streaming#section/Rev.ai-to-Client-Response
* @param {MessageEvent} event
*/
function onMessage(event) {
  var data = JSON.parse(event.data);
  switch (data.type) {
    case "connected":
      statusElement.innerHTML = `Connected`;
      break;
    case "partial":
      currentCell.innerHTML = parseResponse(data);
      break;
    case "final":
      currentCell.innerHTML = parseResponse(data);
      if (data.type == "final") {
        finalsReceived++;
        var row = tableElement.insertRow(finalsReceived);
        currentCell = row.insertCell(0);
        postCaptionToYoutube(parseResponse(data));
      }
      break;
    default:
      // We expect all messages from the API to be one of these types
      console.error("Received unexpected message");
      break;
  }
}

/**
* Transform an audio processing event into a form suitable to be sent to the API. (S16LE or Signed 16 bit Little Edian).
* Then send.
* @param {AudioProcessingEvent} e 
*/
function processAudioEvent(e) {
  if (audioContext.state === 'suspended' || audioContext.state === 'closed' || !websocket) {
    return;
  }

  let inputData = e.inputBuffer.getChannelData(0);

  // The samples are floats in range [-1, 1]. Convert to PCM16le.
  let output = new DataView(new ArrayBuffer(inputData.length * 2));
  for (let i = 0; i < inputData.length; i++) {
    let multiplier = inputData[i] < 0 ? 0x8000 : 0x7fff; // 16-bit signed range is -32768 to 32767
    output.setInt16(i * 2, inputData[i] * multiplier | 0, true); // index, value, little edian
  }

  let intData = new Int16Array(output.buffer);
  let index = intData.length;
  while (index-- && intData[index] === 0 && index > 0) { }
  websocket.send(intData.slice(0, index + 1));
}

function parseResponse(response) {
  var message = "";
  for (var i = 0; i < response.elements.length; i++) {
    message += response.type == "final" ? response.elements[i].value : `${response.elements[i].value} `;
  }
  return message;
}

function resetDisplay() {
  finalsReceived = 0;
  while (tableElement.hasChildNodes()) {
    tableElement.removeChild(tableElement.firstChild);
  }
  var row = tableElement.insertRow(0);
  currentCell = row.insertCell(0);
}

function postCaptionToYoutube(txt) {
  let myHeaders = new Headers();
  myHeaders.append('Content-Type', 'text/plain');
  myHeaders.append('Content-Security-Policy', 'block-all-mixed-content');
  let raw = `${new Date().toISOString().slice(0, -1)}\r\n${txt}\r\n`;

  let requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
    mode: 'no-cors'
  };

  fetch(`${youtube_link}&seq=${seq}`, requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
  seq++;
}